"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marcianise": {
    "a0ce2297": [{
      "hkey": "a689ca42",
      "slug": "marcianise",
      "name": "Marcianise",
      "primary": true,
      "skipSearch": false
    }],
    "castel-airola": [{
      "hkey": "a689ca42",
      "slug": "marcianise",
      "name": "Marcianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5def83c1": [{
      "hkey": "a689ca42",
      "slug": "marcianise",
      "name": "Marcianise",
      "primary": true,
      "skipSearch": false
    }],
    "castel-loriano": [{
      "hkey": "a689ca42",
      "slug": "marcianise",
      "name": "Marcianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;